import * as i18n from "util/i18n";
import * as Yup from "yup";

const useSchema = () => {
    const REQUIRED_TEXT = i18n.get("global.error.required");
    const WRONG_FORMAT = i18n.get("global.incorrect.format");
    const MOBILE_PHONE_ERROR = i18n.get("onboarding.step.verifySMS.mobilePhone.error.empty");
    const stringNullableRequired = Yup.string()
        .transform((currentValue, originalValue) => {
            // Si es null o una cadena no vacía, lo mantiene como está.
            if (originalValue == null || originalValue === "") {
                return undefined;
            }
            // Si es una cadena vacía, lo convierte a undefined para que Yup aplique .required()
            return originalValue;
        })
        .required(REQUIRED_TEXT);

    const stringRequired = Yup.string().required(REQUIRED_TEXT);
    const booleanRequired = Yup.boolean().required(REQUIRED_TEXT);
    const emailRequired = Yup.string()
        .email(i18n.get("onboarding.step.verifyEmail.email.error.invalidFormat"))
        .required(REQUIRED_TEXT);

    const numberNullableRequired = Yup.number()
        .transform((currentValue, originalValue) => {
            // Si es null o una cadena no vacía, lo mantiene como está.
            if (originalValue == null || originalValue === "") {
                return undefined;
            }
            // Si es una cadena vacía, lo convierte a undefined para que Yup aplique .required()
            return originalValue;
        })
        .required(REQUIRED_TEXT)
        .typeError(REQUIRED_TEXT);
    const numberRequired = Yup.number()
        .required(REQUIRED_TEXT)
        .typeError(REQUIRED_TEXT);

    const formatNumberRequired = Yup.number()
        .required(REQUIRED_TEXT)
        .typeError(WRONG_FORMAT);

    const mobilePhoneRequired = Yup.string().required(MOBILE_PHONE_ERROR);

    return {
        stringRequired,
        booleanRequired,
        numberRequired,
        formatNumberRequired,
        emailRequired,
        mobilePhoneRequired,
        stringNullableRequired,
        numberNullableRequired,
    };
};

export default useSchema;
